module.exports = __webpack_public_path__ + "officialStatic/img/logo18.d9e81a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo18.png
// module id = g+ey
// module chunks = 0